/** Keeps camera input blocked until all pending ownership decisions settle. */
export class CameraInteractionGate {
	private _locks = 0;
	private _generation = 0;
	private _requested = true;
	constructor(private _setEnabled: (enabled: boolean) => void) {}
	public setEnabled(enabled: boolean): void {
		this._requested = enabled;
		this._apply();
	}
	public acquire(): () => void {
		const generation = this._generation;
		++this._locks;
		this._apply();
		let released = false;
		return () => {
			if (released || generation !== this._generation) {
				return;
			}
			released = true;
			--this._locks;
			this._apply();
		};
	}
	public reset(): void {
		++this._generation;
		this._locks = 0;
		this._requested = true;
		this._apply();
	}
	private _apply(): void {
		this._setEnabled(this._locks === 0 && this._requested);
	}
}
